import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/i18n";
import { ThemeProvider } from "./context/ThemeContext";
import { ClientProvider } from "./context/ClientContext";
import { NotificationProvider } from "./context/NotificationContext";
import { DialogProvider } from "./context/DialogContext";
import { AuthProvider } from "./context/AuthContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

//TODO: Hapa tunainitialize client provider tuweze kupata client wa service yoyote we desire

root.render(
  <NotificationProvider>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <ClientProvider>
          <DialogProvider>
            <AuthProvider>
              <React.StrictMode>
                <App />
              </React.StrictMode>
            </AuthProvider>
          </DialogProvider>
        </ClientProvider>
      </ThemeProvider>
    </I18nextProvider>
  </NotificationProvider>
);

// FIXME: Optional: Kwa-ajili ya ku-measure performance

reportWebVitals();
